import { Box } from "@mui/material";
import { UseFormReturn } from "react-hook-form";
import InputMascarado from "../../input-mascarado/InputMascarado";
import Input from "../../input/input";
import { mascaraCpf } from "../../../../utils/mascaras";

interface PessoaFisicaFormProps {
  methods: UseFormReturn<any>;
  disabled?: boolean;
  mdDown?: any;
}

export function PessoaFisicaFormPart({
  methods,
  mdDown,
  disabled = false,
}: PessoaFisicaFormProps) {
  return (
    <Box display="grid" gridTemplateColumns={mdDown ? "1fr" : "1fr 1fr"} gap="20px" width="100%">
      <InputMascarado
        name="cpf"
        methods={methods}
        label="Digite o CPF"
        mask={mascaraCpf}
        disabled={disabled}
      />
      <Input
        name="fullName"
        label="Nome Completo"
        methods={methods}
        disabled={disabled}
      />
    </Box>
  );
}
